module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud3_m_v2.716c50b13ec4e61b0e6650880c88e68b.png";